/* Metafield bundle picker — externalized from snippets/metafield-bundle-picker.liquid
   (logic unchanged). Liquid data (inventory map, names, bundle id/price) comes
   from the JSON config block <script type="application/json"
   data-bundle-picker-config>. Requires sneak-money.js for price formatting. */
(function () {
  if (window.__sneakMetafieldBundlePickerLoaded) return;
  window.__sneakMetafieldBundlePickerLoaded = true;

  function readConfig() {
    var el = document.querySelector('[data-bundle-picker-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Inventory data from Liquid — JS uses this for 48h/incoming icons
  let bundleInventoryData = {};
  let bundleProductNames = {};
  let bundleSavingsTranslation = '';
  let bundleCfg = null;

  // Bundle picker initialization flag
  let bundlePickerInitialized = false;
  let _bundlePickerAC = null; // AbortController to tear down stale listeners

  function initializeBundlePicker() {
    bundleCfg = readConfig() || bundleCfg;
    if (!bundleCfg) return;
    bundleInventoryData = bundleCfg.inventory || {};
    bundleProductNames = bundleCfg.productNames || {};
    bundleSavingsTranslation = bundleCfg.savingsTranslation || '';

    bundlePickerInitialized = true;

    // Abort previous listeners so they don't stack on re-init
    if (_bundlePickerAC) _bundlePickerAC.abort();
    _bundlePickerAC = new AbortController();
    const _sig = { signal: _bundlePickerAC.signal };

    const bundleInterface = document.querySelector('[data-bundle-interface]');
    const bundleAddButton = document.querySelector('[data-bundle-add]');

    if (!bundleInterface || !bundleAddButton) {
      return;
    }
    let selectedVariants = {
      main: null,
      partner: null
    };

    // Track currently selected main product handle
    let currentMainProductHandle = bundleCfg.mainProductHandle;

    // Initialize button state
    updateBundleTotal();

    // Handle single pants type option
    const singlePantsTypeInput = document.getElementById('single-pants-type-input');
    if (singlePantsTypeInput) {
      const pantsType = singlePantsTypeInput.dataset.pantsType;
      const productHandle = singlePantsTypeInput.dataset.producthandle;

      // Set the selected variant
      selectedVariants.partner = {
        pantsType: pantsType,
        productHandle: productHandle
      };

      // Load the size variants immediately with a small delay to ensure DOM is ready
      setTimeout(() => {
        updatePartnerProduct(productHandle);
        updateBundleTotal();
      }, 100);
    }

    // Bundle is always open - no toggle functionality needed


    // Function to update main product
    function updateMainProduct(productHandle) {
      currentMainProductHandle = productHandle;

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          // Update main product title
          const titleLink = document.getElementById('main-product-title-link');
          if (titleLink) {
            titleLink.textContent = product.title;
            titleLink.href = `/products/${productHandle}`;
          }

          // Update main product image
          const imageContainer = document.getElementById('main-product-image');
          if (imageContainer && product.featured_image) {
            const imageUrl = product.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_200x.$1');
            const imageLink = document.getElementById('main-product-image-link');
            if (imageLink) {
              imageLink.href = `/products/${productHandle}`;
              imageLink.innerHTML = `<img src="${imageUrl}" alt="${product.title}" loading="lazy" style="width: 100%; height: 100%; object-fit: contain;">`;
            } else {
              imageContainer.innerHTML = `
                <a href="/products/${productHandle}" id="main-product-image-link">
                  <img src="${imageUrl}" alt="${product.title}" loading="lazy" style="width: 100%; height: 100%; object-fit: contain;">
                </a>
              `;
            }
          }

          // Update main product price
          const priceContainer = document.getElementById('main-product-price');
          if (priceContainer) {
            const bundlePrice = bundleCfg.finalPriceCents;
            const individualPrice = bundlePrice / 2;
            const comparePrice = product.compare_at_price || product.price;
            const comparePriceCents = comparePrice / 100;
            const individualPriceCents = individualPrice / 100;

            if (comparePriceCents > individualPriceCents) {
              priceContainer.innerHTML = `
                <sale-price class="text-sm text-on-sale">
                  <span class="sr-only">REA-pris</span>${formatMoney(individualPrice)}
                </sale-price>
                <compare-at-price class="text-subdued line-through text-xs">
                  <span class="sr-only">Pris</span>${formatMoney(comparePrice)}
                </compare-at-price>
              `;
            } else {
              priceContainer.innerHTML = `
                <price class="text-sm">${formatMoney(individualPrice)}</price>
              `;
            }
          }

          // Update bundle header pricing
          updateBundleHeaderPricing(product);


          // Update main product variants
          const variantsContainer = document.getElementById('main-product-variants');
          if (variantsContainer && product.options) {
            variantsContainer.innerHTML = '';

            product.options.forEach((option, optionIndex) => {
              option.values.forEach(value => {
                // Find matching variant
                const matchingVariant = product.variants.find(v => v.option1 === value);
                const isVariantDisabled = matchingVariant ? !matchingVariant.available : true;

                const label = document.createElement('label');
                label.className = `block-swatch${isVariantDisabled ? ' is-disabled' : ''}`;

                const input = document.createElement('input');
                input.type = 'radio';
                input.name = `main-${option.name.toLowerCase().replace(/\s+/g, '-')}`;
                input.value = value;
                input.dataset.size = value;
                input.dataset.producthandle = productHandle;
                input.dataset.option = option.name;
                if (isVariantDisabled) input.disabled = true;

                const variantInfo = document.createElement('div');
                variantInfo.className = 'variant-info';

                // Use Liquid-provided inventory data for 48h/incoming icons
                const invData = bundleInventoryData[productHandle];
                const invVariant = invData?.variants?.[value];
                if (invVariant) {
                  if (invVariant.qty > 0) {
                    const stockSpan = document.createElement('span');
                    stockSpan.className = 'in-stock';
                    stockSpan.innerHTML = '<svg class="icon"><use xlink:href="#48h-icon"></use></svg>';
                    variantInfo.appendChild(stockSpan);
                  } else if (invVariant.policy === 'continue' && invVariant.backorderDays > 0) {
                    /* Ships in about a week (custom.backorder_days) */
                    const boSpan = document.createElement('span');
                    boSpan.className = 'incoming backorder-week';
                    boSpan.innerHTML = '<svg class="icon"><use xlink:href="#backorder-icon"></use></svg>';
                    variantInfo.appendChild(boSpan);
                  } else if (invVariant.policy === 'continue' && invData.incoming) {
                    const incomingSpan = document.createElement('span');
                    incomingSpan.className = 'incoming';
                    incomingSpan.innerHTML = '<svg class="icon"><use xlink:href="#incoming-icon"></use></svg>';
                    variantInfo.appendChild(incomingSpan);
                  }
                }

                const variantLabel = document.createElement('span');
                variantLabel.className = 'variant-label';
                variantLabel.textContent = value;
                variantInfo.appendChild(variantLabel);

                // Use Liquid inventory price if available, fall back to API price
                const variantPrice = invVariant?.price ?? matchingVariant?.price;
                if (variantPrice) {
                  const priceSpan = document.createElement('span');
                  priceSpan.className = 'variant-price';
                  priceSpan.textContent = formatMoney(variantPrice);
                  variantInfo.appendChild(priceSpan);
                }

                label.appendChild(input);
                label.appendChild(variantInfo);
                variantsContainer.appendChild(label);
              });
            });
          }
        })
        .catch(() => {});
    }

    // Helper function to format money (cents to formatted string)
    function formatMoney(cents) {
      return window.SneakMoney.format(cents, (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR');
    }

    // Function to update bundle header pricing
    function updateBundleHeaderPricing(mainProduct) {
      const partnerProductHandle = selectedVariants.partner?.productHandle;
      if (!partnerProductHandle) {
        // Try to get partner product from current selection
        const pantsTypeInput = document.querySelector('input[name="partner-pants-type"]:checked');
        if (pantsTypeInput) {
          partnerProductHandle = pantsTypeInput.dataset.producthandle;
        }
      }

      if (partnerProductHandle) {
        fetch(`/products/${partnerProductHandle}.js`)
          .then(response => response.json())
          .then(partnerProduct => {
            const mainCompareAt = (mainProduct.compare_at_price || mainProduct.price) / 100;
            const partnerCompareAt = (partnerProduct.compare_at_price || partnerProduct.price) / 100;
            const bundleCompareAtTotal = (mainCompareAt + partnerCompareAt) * 100;
            const bundlePrice = bundleCfg.finalPriceCents;
            const bundleSavingsAmount = bundleCompareAtTotal - bundlePrice;
            const bundleSavingsPercentage = Math.round((bundleSavingsAmount / bundleCompareAtTotal) * 100);

            const comparePriceEl = document.getElementById('bundle-compare-price');
            const savingsBadge = document.getElementById('bundle-savings-badge');

            if (comparePriceEl) {
              comparePriceEl.textContent = formatMoney(bundleCompareAtTotal);
            }

            if (savingsBadge) {
              if (bundleSavingsAmount > 0) {
                savingsBadge.textContent = '-' + formatMoney(bundleSavingsAmount);
                savingsBadge.style.display = '';
              } else {
                savingsBadge.style.display = 'none';
              }
            }
          })
          .catch(() => {});
      }
    }

    // Size selection for main product
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name^="main-"]')) {
        const size = e.target.dataset.size;
        // Use the currently selected main product handle
        const productHandle = currentMainProductHandle || e.target.dataset.producthandle;

        if (!productHandle) {
          return;
        }

        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            if (!product.variants) {
              return;
            }

            // Find variant by exact match on option value (not includes)
            const variant = product.variants.find(v => {
              if (!v.options || v.options.length === 0) return false;
              // Check if any option exactly matches the selected size
              return v.options.some(opt => opt === size) || v.title === size;
            });

            if (variant) {
              selectedVariants.main = {
                variantId: variant.id,
                size: size,
                productHandle: productHandle
              };
              updateBundleTotal();
            }
          })
          .catch(() => {});
      }
    }, _sig);

    // Pants type selection
    document.addEventListener('change', function(e) {
      if (e.target.matches('input[name="partner-pants-type"]')) {
        const pantsType = e.target.dataset.pantsType;
        const productHandle = e.target.dataset.producthandle;

        if (!productHandle) {
          return;
        }

        // Clear any previously selected partner size and variant ID
        selectedVariants.partner = {
          pantsType: pantsType,
          productHandle: productHandle,
          variantId: null,
          size: null
        };

        // Hide size selection temporarily while loading new product
        const sizeSelection = document.getElementById('partner-size-selection');
        if (sizeSelection) {
          sizeSelection.style.display = 'none';
        }

        // Show placeholder text while loading
        const placeholder = document.getElementById('size-selection-placeholder');
        if (placeholder) {
          placeholder.style.display = 'block';
        }

        // Update partner product
        updatePartnerProduct(productHandle);

        // Update bundle total to enable/disable button
        updateBundleTotal();
      }
    }, _sig);

    // Size selection for partner product
    document.addEventListener('change', function(e) {
      if (e.target.matches('#partner-size-selection input[type="radio"]')) {
        const size = e.target.dataset.size;
        const productHandle = e.target.dataset.producthandle;

        // Find the variant for this size
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            if (!product.variants) {
              return;
            }

            // Find variant by exact match on option value (not includes)
            const variant = product.variants.find(v => {
              if (!v.options || v.options.length === 0) return false;
              // Check if any option exactly matches the selected size
              return v.options.some(opt => opt === size) || v.title === size;
            });

            if (variant) {
              selectedVariants.partner = {
                ...selectedVariants.partner,
                variantId: variant.id,
                size: size
              };
              updateBundleTotal();
            }
          });
      }
    }, _sig);

    // Update partner product function
    function updatePartnerProduct(productHandle) {
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          // Update product title
          const titleElement = document.getElementById('partner-product-title');
          if (titleElement) {
            titleElement.textContent = product.title;
            titleElement.href = `/products/${productHandle}`;
          }

          // Update product image - let it scale to container
          const imageElement = document.getElementById('partner-product-image');
          if (imageElement && product.featured_image) {
            // Create properly sized image URL (200px width) but let it scale
            const imageUrl = product.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_200x.$1');
            imageElement.innerHTML = `
              <a href="/products/${productHandle}">
                <img src="${imageUrl}" alt="${product.title}" loading="lazy" style="width: 100%; height: 100%; object-fit: contain; object-position: center;">
              </a>
            `;
          }

          // Update size options - show ALL options, not just Size
          const sizeSelection = document.getElementById('partner-size-selection');
          if (sizeSelection) {
            sizeSelection.innerHTML = '';

            // Show all options and their values
            product.options.forEach((option, optionIndex) => {
              option.values.forEach(value => {
                const matchingVariant = product.variants.find(v => v.option1 === value);
                const isVariantDisabled = matchingVariant ? !matchingVariant.available : true;

                const label = document.createElement('label');
                label.className = `block-swatch${isVariantDisabled ? ' is-disabled' : ''}`;

                const input = document.createElement('input');
                input.type = 'radio';
                input.name = `partner-${option.name.toLowerCase().replace(/\s+/g, '-')}`;
                input.value = value;
                input.dataset.size = value;
                input.dataset.producthandle = productHandle;
                input.dataset.option = option.name;
                if (isVariantDisabled) input.disabled = true;

                const variantInfo = document.createElement('div');
                variantInfo.className = 'variant-info';

                // Use Liquid-provided inventory data for 48h/incoming icons
                const pInvData = bundleInventoryData[productHandle];
                const pInvVariant = pInvData?.variants?.[value];
                if (pInvVariant) {
                  if (pInvVariant.qty > 0) {
                    const stockSpan = document.createElement('span');
                    stockSpan.className = 'in-stock';
                    stockSpan.innerHTML = '<svg class="icon"><use xlink:href="#48h-icon"></use></svg>';
                    variantInfo.appendChild(stockSpan);
                  } else if (pInvVariant.policy === 'continue' && pInvVariant.backorderDays > 0) {
                    /* Ships in about a week (custom.backorder_days) */
                    const boSpan = document.createElement('span');
                    boSpan.className = 'incoming backorder-week';
                    boSpan.innerHTML = '<svg class="icon"><use xlink:href="#backorder-icon"></use></svg>';
                    variantInfo.appendChild(boSpan);
                  } else if (pInvVariant.policy === 'continue' && pInvData.incoming) {
                    const incomingSpan = document.createElement('span');
                    incomingSpan.className = 'incoming';
                    incomingSpan.innerHTML = '<svg class="icon"><use xlink:href="#incoming-icon"></use></svg>';
                    variantInfo.appendChild(incomingSpan);
                  }
                }

                const variantLabel = document.createElement('span');
                variantLabel.className = 'variant-label';
                variantLabel.textContent = value;
                variantInfo.appendChild(variantLabel);

                const pVariantPrice = pInvVariant?.price ?? matchingVariant?.price;
                if (pVariantPrice) {
                  const priceSpan = document.createElement('span');
                  priceSpan.className = 'variant-price';
                  priceSpan.textContent = formatMoney(pVariantPrice);
                  variantInfo.appendChild(priceSpan);
                }

                label.appendChild(input);
                label.appendChild(variantInfo);
                sizeSelection.appendChild(label);
              });
            });

            // Show the size selection after populating it
            sizeSelection.style.display = 'flex';

            // Hide the placeholder text
            const placeholder = document.getElementById('size-selection-placeholder');
            if (placeholder) {
              placeholder.style.display = 'none';
            }
          }
        });
    }

    // Update bundle total function
    function updateBundleTotal() {
      if (!bundleAddButton) {
        return;
      }

      const mainSelected = selectedVariants.main && selectedVariants.main.variantId;
      const partnerSelected = selectedVariants.partner && selectedVariants.partner.variantId;
      const pantsTypeSelected = selectedVariants.partner && selectedVariants.partner.pantsType;

      var ready = !!(mainSelected && partnerSelected && pantsTypeSelected);
      bundleAddButton.disabled = !ready;

      /* Gather stock info for each bundle item */
      var bundleStockItems = [];
      if (selectedVariants.main && selectedVariants.main.size) {
        var mHandle = selectedVariants.main.productHandle;
        var mInv = bundleInventoryData[mHandle];
        var mVariant = mInv ? mInv.variants[selectedVariants.main.size] : null;
        bundleStockItems.push({
          title: selectedVariants.main.size,
          product: bundleProductNames.main,
          qty: mVariant ? mVariant.qty : 0,
          available: mVariant ? mVariant.available : false,
          incoming: mInv ? mInv.incoming : false,
          backorderDays: mVariant ? (mVariant.backorderDays || 0) : 0,
          policy: mVariant ? mVariant.policy : 'deny'
        });
      }
      if (selectedVariants.partner && selectedVariants.partner.size) {
        var pHandle = selectedVariants.partner.productHandle;
        var pInv = bundleInventoryData[pHandle];
        var pVariant = pInv ? pInv.variants[selectedVariants.partner.size] : null;
        bundleStockItems.push({
          title: selectedVariants.partner.size,
          product: bundleProductNames.partner,
          qty: pVariant ? pVariant.qty : 0,
          available: pVariant ? pVariant.available : false,
          incoming: pInv ? pInv.incoming : false,
          backorderDays: pVariant ? (pVariant.backorderDays || 0) : 0,
          policy: pVariant ? pVariant.policy : 'deny'
        });
      }

      document.dispatchEvent(new CustomEvent('bundle:state', { detail: {
        ready: ready,
        mainVariantId: selectedVariants.main ? selectedVariants.main.variantId : null,
        partnerVariantId: selectedVariants.partner ? selectedVariants.partner.variantId : null,
        stockItems: bundleStockItems
      } }));
    }

    // Handle bundle add to cart
    bundleAddButton.addEventListener('click', function(e) {
      if (e.target.disabled) {
        e.preventDefault();
        return false;
      }

      // Validate that both variants are selected and have valid IDs
      if (!selectedVariants.main || !selectedVariants.main.variantId) {
        e.preventDefault();
        return false;
      }

      if (!selectedVariants.partner || !selectedVariants.partner.variantId) {
        e.preventDefault();
        return false;
      }

      /* A side with no stock is a preorder; merge the marker into the bundle
         properties (never replace them, the Function keys on _bundle_*). */
      const mainInv = bundleInventoryData[selectedVariants.main.productHandle];
      const mainInvVariant = mainInv && mainInv.variants ? mainInv.variants[selectedVariants.main.size] : null;
      const partnerInv = bundleInventoryData[selectedVariants.partner.productHandle];
      const partnerInvVariant = partnerInv && partnerInv.variants ? partnerInv.variants[selectedVariants.partner.size] : null;
      const stampIf = function (outOfStock, props) {
        return outOfStock && window.sneakPreorder ? window.sneakPreorder.stampProps(props) : props;
      };

      const items = [
        {
          id: selectedVariants.main.variantId,
          quantity: 1,
          properties: stampIf(!(mainInvVariant && mainInvVariant.qty > 0), {
            _bundle: 'true',
            _bundle_id: String(bundleCfg.bundleId),
            _bundle_title: String(bundleCfg.bundleName),
            _bundle_final_price: bundleCfg.finalPriceEuros
          })
        },
        {
          id: selectedVariants.partner.variantId,
          quantity: 1,
          properties: stampIf(!(partnerInvVariant && partnerInvVariant.qty > 0), {
            _bundle: 'true',
            _bundle_id: String(bundleCfg.bundleId),
            _bundle_title: String(bundleCfg.bundleName),
            _bundle_final_price: bundleCfg.finalPriceEuros
          })
        }
      ];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => response.json())
      .then(data => {
        // Close the purchase overlay first
        const purchaseOverlay = document.querySelector('.purchase-overlay-drawer');
        if (purchaseOverlay && purchaseOverlay.hide) {
          purchaseOverlay.hide();
        }

        // Trigger cart refresh and wait for it to complete
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        // Wait for cart to refresh, then open drawer
        setTimeout(() => {
          // Try multiple methods to open cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          const cartButton = document.querySelector('[data-cart-drawer-toggle]');

          if (cartDrawer && cartDrawer.show) {
            cartDrawer.show();
          } else if (cartButton) {
            cartButton.click();
          } else {
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('drawer:open'));
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          }

          // Force refresh the cart drawer content after opening
          setTimeout(() => {
            // Try to refresh cart sections directly
            fetch('/cart/sections.js')
              .then(response => response.json())
              .then(sections => {
                // Update cart drawer if it exists
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  // Try to trigger a refresh on the cart drawer
                  if (cartDrawer.refresh) {
                    cartDrawer.refresh();
                  }
                }

                // Dispatch refresh events
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:updated'));
              })
              .catch(() => {
                // Fallback to just dispatching events
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:updated'));
              });
          }, 200);
        }, 500);
      })
      .catch(() => {});
    }, _sig);
  }

  // Initialize bundle picker when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBundlePicker);
  } else {
    initializeBundlePicker();
  }

  // Listen for variant changes to re-initialize bundle picker
  document.addEventListener('variant:change', function(event) {
    bundlePickerInitialized = false;
    setTimeout(initializeBundlePicker, 100);
  });

  // Also listen for product form changes
  document.addEventListener('change', function(event) {
    if (event.target.matches('input[name="id"]') || event.target.matches('select[name="id"]')) {
      bundlePickerInitialized = false;
      setTimeout(initializeBundlePicker, 100);
    }
  });

  // Re-init after Section Rendering API swaps (injected scripts don't run)
  document.addEventListener('shopify:section:load', function () {
    bundlePickerInitialized = false;
    setTimeout(initializeBundlePicker, 100);
  });
})();
